import _ from 'underscore';
import queryString from 'query-string';
import {
  RequestContract,
  ResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';
import stringify from 'json-stable-stringify';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { parseSearch, getDefaultHeaderObj } from '../../../request-contract-helper';

function odataUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
    startDate,
    endDate,
    granularity,
  } = variables;
  const { descriptor } = locator;
  const { cid, aid, campaignId } = descriptor;

  if (!startDate || !endDate) {
    throw new Error('Performance time series function call need startDate and endDate of "yyyy-mm-dd" format');
  }

  if (!granularity) {
    throw new Error('Performance time series function call need granularity');
  }

  const functionEdmResource = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns['Default.PerformanceTimeSeries'];
  const functionCallParameters = {
    granularity: `Enum.Granularity'${granularity}'`,
    startDate,
    endDate,
    comparisonStartDate: null,
    comparisonEndDate: null,
    metrics: "'All'",
    movingAverage: false,
  };

  const { path } = functionEdmResource.$call(functionCallParameters);
  const smartFilter = "(CampaignType eq Enum.CampaignType'Smart')";
  const search = {
    top: 20,
    filter: {
      where: campaignId ? `${smartFilter} and Id eq ${campaignId}` : smartFilter,
    },
    count: true,
    returnphonecalls: true,
  };

  const parsedSearch = parseSearch(search);
  const searchCompact = _.omit(parsedSearch, x => _.isNull(x) || _.isUndefined(x));
  const searchString = _.isEmpty(searchCompact) ? '' : `?${queryString.stringify(searchCompact)}`;

  return `${path}${searchString}`;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

export class PerformanceTimeSeriesRequestContract extends RequestContract {
  constructor(options) {
    super(Object.assign({}, {
      schema,
      dataPath: 'customer:account:performance_time_series',
      verb: requestVerbs.GET,
      uriFactoryFn: odataUrlFactory,
      headerFactoryFn: odataHeaderFactory,
      keySelector: chartData => chartData.ClientId,
    }, options));
  }
}

export class PerformanceTimeSeriesResponseContract extends ResponseContract {
  constructor(options) {
    super(Object.assign({}, {
      responseType: responseTypes.ENTITY,
      keySelector: chartData => chartData.ClientId,
      processorFn: (response, request) => ({
        ...response,
        ClientId: stringify(request.variables),
      }),
    }, options));
  }
}
